import DropSelector from 'sma.admin/components/dropdowns/dropselector';
import {MultiSelectSearch} from 'sma.common/components/multi_select_search';
import {randomString} from 'sma.common/utils';

var DatePicker = require('sma.admin/components/datepicker');

const multiSelectSearch = require('sma.admin/components/partials/multi_select_search.mustache');

class Value {
	constructor (filterInfo) {
		this.initialize(filterInfo)
	}

	initialize (filterInfo) {
		this.filterInfo = filterInfo;

		this.input = null;
		this.value = null;

		this.buildElement();
		this.delegate();

	}

	set (value) {
		this.value = value;

		if (this.input !== null) {
			this.input.val(this.value);
		}
	}

	getElement () {
		return this.input;
	}

	buildElement () {

	}

	afterAppended () {

	}

	delegate () {
		this.input.on('change', $.proxy(function(e) {
			this.set($(e.target).val());
		}, this));
	}

	serialize () {
		this.input.trigger('change');
		return {value: this.value};
	}
}

class Text extends Value {
	buildElement () {
		this.input = $('<input>', {
			type: 'text',
			'class': 'text form-control'
		});
	}
}

class Choice extends Value {

	initialize (filterInfo){
		this.multiple = this.multiple || false;
		this.choices = [];

		if (filterInfo !== undefined && filterInfo.choices !== undefined) {
			this.choices = filterInfo.choices;
		}

		super.initialize(filterInfo);

	}

	getElement () {
		return this.selector.wrapped;
	}

	set (value) {
		this.value = value;
		this.selector.val(value);
	}

	createInput (choiceOptions, multiple) {
		let choices = [];

		//TODO Make sure this is the only format
		//There maybe another format in use,
		for (var i in choiceOptions) {
			if (typeof choiceOptions[i] != 'object') { // Surveys format, don't change
				choices.push({
					value: i,
					label: choiceOptions[i]
				});
			}
			else if (choiceOptions[i].header)
				choices.push({
					value: null,
					header: true,
					label: choiceOptions[i].text
				});
			else
				choices.push({
					value: choiceOptions[i].id,
					header: false,
					label: choiceOptions[i].label
				});
		}

		let input = $(Choice.SelectTemplate({choices: choices}));

		if (multiple) {
			input.attr('multiple', 'multiple');
		}

		if (this.value == null && (this.autoSetDefault === undefined || this.autoSetDefault)) {
			input.find('option:first').attr('selected', 'selected');

			if (!multiple) {
				this.value = input.find('option:first').attr('value');
			} else {
				this.value = [input.find('option:first').attr('value')];
			}
		}

		return input
	}

	buildElement () {
		this.input = this.createInput(this.choices, this.multiple);

		this.selector = this.input;
		this.input.show();

		this.selector = new DropSelector({
			multiple: !!this.multiple,
			fullWidth: true,
			dropdownToggle: true,
			buttonSize: 'btn-sm',
			$selectEl: this.input
		});
	}
}

Choice.SelectTemplate = _.template("\
<select class='choices'>\
<% var firstHeader = true; _.each(choices, function(choice) { %>\
<% if (choice.header) { %>\
    <% if (!firstHeader) { %>\
    	<% firstHeader = false; %>\
    <% } else { %>\
    	</optgroup>\
    <% } %>\
    <optgroup label='<%= choice.label %>'>\
<% } else { %>\
	<option value='<%= choice.value %>'><%= choice.label %></option>\
<% } %>\
<% }); %>\
<% if (!firstHeader) { %>\
	</optgroup>\
<% } %>\
</select>\
");

class MultipleChoice extends Choice {
	initialize (filterInfo){
		this.multiple = true;
		super.initialize(filterInfo);
	}

	set (value) {
		this.value = value;
		this.selector.val(value);
	}
}

class MultipleChoiceAndSearch extends MultipleChoice {
	getElement () {
		return this.input;
	}

	createInput(choiceOptions, multiple) {
		const choices = [];

		this.prefix = this.filterInfo.id || 'multi_select_search_el';
		this.suffix = randomString(20);

		for (const i in choiceOptions) {
			if (typeof choiceOptions[i] != 'object') {
				choices.push({
					inputLabel: choiceOptions[i],
					value: i,
					inputId: `${this.prefix}_${i}_${this.suffix}`,
					inputName: this.prefix,
				});
			} else {
				choices.push({
					inputLabel: choiceOptions[i].label,
					value: choiceOptions[i].value,
					inputId: `${this.prefix}_${i}_${this.suffix}`,
					inputName: this.prefix,
				});
			}
		}

		const input = $(multiSelectSearch({
			strings: {
				done: gettext('done'),
				selected: gettext('Selected:'),
				search: gettext('Search...'),
			},
			checkedItems: gettext('Select...'),
			checkedItemsLength: 0,
			choices,
		}));

		if (multiple) {
			input.attr('multiple', 'multiple');
		}

		if (this.value == null && (this.autoSetDefault === undefined || this.autoSetDefault)) {
			input.find('option:first').attr('selected', 'selected');

			if (!multiple) {
				this.value = input.find('option:first').attr('value');
			} else {
				this.value = [input.find('option:first').attr('value')];
			}
		}

		return input;
	}

	buildElement() {
		this.input = this.createInput(this.choices, this.multiple);
		this.input.show();
		this.selector = this.input;

		this.multiSelectSearch = new MultiSelectSearch();
	}

	set (value) {
		this.value = value;
		value.forEach((i, val) => {
			this.input.find(`input[value="${i}"]`).attr('checked', 'checked');
		});
		if (value.length > 0) {
			this.input.find('.sma-multi-select-selected-count').text(value.length);
		}
	}

	delegate () {
		this.input.on('change', (e) => {
			const selected = [].slice.call(
				e.currentTarget.querySelectorAll(`input[name="${this.prefix}"]:checked`),
			).map(input => input.value);
			this.set(selected);
		});
	}
}

class ValueAndMultipleChoice extends MultipleChoice {
	buildElement () {
		this.input1 = $('<input>', {
			type: 'text',
			'class': 'text form-control'
		});
		super.buildElement();
		this.selector.selectAll();
	}

	getElement() {
		var div = $('<div class="sma-condition-value-multi">');
		div.append(this.input1);
		div.append(this.selector.wrapped);
		return div;
	}

	set(value) {
		this.value = value;
		if (value.indexOf(":") == "-1") {
			this.input1.val(value);
		} else {
			var values = value.split(':');
			this.input1.val(values[0]);
			var selectorVals = values[1].split(',');
			this.selector.val(selectorVals);
		}
	}

	setSelector(value) {
		var inputVal = this.input1.val();
		this.value = `${inputVal}:${value}`;
		this.selector.val(value);
	}

	setInput(value) {
		var selectorVal = this.selector.val();
		this.value = `${value}:${selectorVal}`;
		this.input1.val(value)
	}

	delegate () {
		this.input1.on('change', $.proxy(function(e) {
			this.setInput($(e.target).val());
		}, this));

		this.input.on('change', $.proxy(function(e) {
			this.setSelector($(e.target).val());
		}, this));
	}
}

class ChoiceAndChoice extends Choice {
	initialize (filterInfo) {
		this.multiple = this.multiple || false;
		this.choices1 = [];

		if (filterInfo !== undefined && filterInfo.choices1 !== undefined) {
			this.choices1 = filterInfo.choices1;
		}

		if (filterInfo !== undefined && filterInfo.choices2 !== undefined) {
			this.choices2 = filterInfo.choices2;
		}
		super.initialize(filterInfo);
	}

	getElement() {
		const div = $('<div class="sma-condition-select-select">');
		div.append(this.selector1.wrapped);
		div.append(this.selector2.wrapped);
		return div;
	}

	set(value) {
		this.value = value;
		if (value.indexOf(":") == "-1") {
			this.selector1.val(value);
		} else {
			const values = value.split(':');

			const selector1Vals = values[0].split(',');
			this.selector1.val(selector1Vals);

			this.selector2.val(values[1]);
		}
	}

	buildElement () {
		this.input1 = this.createInput(this.choices1, this.multiple);
		this.input1.show();

		this.selector1 = new DropSelector({
			multiple: this.multiple,
			fullWidth: true,
			dropdownToggle: true,
			buttonSize: 'btn-sm',
			$selectEl: this.input1
		});

		this.input2 = this.createInput(this.choices2, false);
		this.input2.show();

		this.selector2 = new DropSelector({
			multiple: false,
			fullWidth: true,
			dropdownToggle: true,
			buttonSize: 'btn-sm',
			$selectEl: this.input2
		});

		super.buildElement();
	}

	setSelector1(value) {
		const selector2 = this.selector2.val();
		this.value = `${value}:${selector2}`;
		this.selector1.val(value);
	}

	setSelector2(value) {
		const selector1 = this.selector1.val();
		this.value = `${selector1}:${value}`;
		this.selector2.val(value);
	}

	delegate () {
		this.input1.on('change', $.proxy(function(e) {
			this.setSelector1($(e.target).val());
		}, this));

		this.input2.on('change', $.proxy(function(e) {
			this.setSelector2($(e.target).val());
		}, this));
	}
}

class MultiAndChoice extends ChoiceAndChoice {
	initialize(filterInfo) {
		this.multiple = true;
		super.initialize(filterInfo);
	}
}

class DateTime extends Value {
	buildElement () {
		this.input = $('<input>', {
			class: 'form-control',
			type: 'text',
		});

	}

	afterAppended () {
		new DatePicker(this.input);
	}
}

class TeamAndStage extends MultipleChoice {
	initialize (filterInfo) {
		this.stageChoices = filterInfo.stage_choices;
		this.noPredicate = true;
		this.autoSetDefault = false;

		super.initialize(filterInfo);

		if (this.value === null) {
			this.value = {
				teams: [],
				stage: this.stageChoices[0].id
			};
		}
	}

	buildElement () {
		this.stageSelectorInput = $('<select>');

		for (let stage of this.stageChoices) {
			let option = $('<option>', {value: stage.id, text: stage.label});
			this.stageSelectorInput.append(option);
		}

		this.stageSelector = new DropSelector({
			multiple: false,
			fullWidth: true,
			dropdownToggle: true,
			buttonSize: 'btn-sm',
			$selectEl: this.stageSelectorInput
		});

		super.buildElement();
	}

	getElement() {
		var div = $('<div class="sma-condition-team-and-stage row">');

		let stageColumn = $('<div>').addClass('col');
		let teamColumn = $('<div>').addClass('col');
		
		stageColumn.append($('<span>').text(gettext('In stage')));
		stageColumn.append(this.stageSelector.wrapped);
		
		teamColumn.append($('<span>').text(gettext('By team')));
		teamColumn.append($('<small>').addClass('text-muted').text(gettext('(Optional)')));
		teamColumn.append(this.selector.wrapped);
		
		return div.append(stageColumn, teamColumn);
	}

	set(value) {
		this.setTeams(value.teams);
		this.setStage(value.stage);
		
		if (this.value.teams !== undefined && this.value.teams.length > 0) {
			this.selector.val(value.teams);
		} else {
			this.value.teams = [];
		}

		if (this.value.stage !== undefined) {
			this.stageSelector.val(this.value.stage);
		} else {
			this.value.stage = this.stageChoices[0].id;
		}
	}

	setTeams(value) {
		this.value.teams = value.filter(x => x !== '-1');
	}

	setStage(value) {
		this.value.stage = value;
	}

	delegate () {
		this.stageSelector.$selectEl.on('change', $.proxy(function(e) {
			this.setStage($(e.target).val());
		}, this));

		this.input.on('change', $.proxy(function(e) {
			this.setTeams($(e.target).val());
		}, this));
	}

	serialize() {
		return this.value;
	}
}

Value.TypeMap = {
	'text': Text,
	'choice': Choice,
	'multiplechoice': MultipleChoice,
	'datetime': DateTime,
	'noop': null,
	'value_and_multi': ValueAndMultipleChoice,
	'team_and_stage': TeamAndStage,
	'choice_and_choice': ChoiceAndChoice,
	'multi_and_choice': MultiAndChoice,
	'multi_with_search': MultipleChoiceAndSearch,
};


module.exports = {
	Value: Value,
	Text: Text,
	Choice: Choice,
	MultipleChoice: MultipleChoice,
	DateTime: DateTime,
	ValueAndMultipleChoice: ValueAndMultipleChoice,
	TeamAndStage
};
